export default __webpack_public_path__ + "static/media/campaings.7661ec3a.png";